"use strict";
// tslint:disable
/**
 * Learning platform
 * API for ROH Learning platform
 *
 * The version of the OpenAPI document: 1.0.3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeacherSpecialization = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var TeacherSpecialization;
(function (TeacherSpecialization) {
    TeacherSpecialization["AClassTeacher"] = "A class teacher";
    TeacherSpecialization["AFreelanceSpecialist"] = "A freelance specialist";
    TeacherSpecialization["ATeachingAssistant"] = "A teaching Assistant";
    TeacherSpecialization["Governor"] = "Governor";
    TeacherSpecialization["Other"] = "Other";
    TeacherSpecialization["SeniorLeadershipTeam"] = "Senior Leadership Team";
    TeacherSpecialization["TheSchoolsArtsLead"] = "The school's arts lead";
    TeacherSpecialization["TheSchoolsDancePELead"] = "The school's dance/P.E. lead";
    TeacherSpecialization["TheSchoolsDesignLead"] = "The school's design lead";
    TeacherSpecialization["TheSchoolsMusicLead"] = "The school's music lead";
})(TeacherSpecialization = exports.TeacherSpecialization || (exports.TeacherSpecialization = {}));
